import toast from "react-hot-toast";
import ColorSchema from "./Color/index.tsx";
import { BsFillCheckCircleFill, BsFillInfoCircleFill } from "react-icons/bs";
import { RiCloseCircleFill } from "react-icons/ri";
import { AiFillWarning } from "react-icons/ai";
import { GrClose } from "react-icons/gr";

export default function ToastCustomize({ ...data }) {
  const styles = {
    duration: data.duration,
    position: data.position,
  };
  const ToastType = () => {
    if (data.toastType == "success") {
      return (
        <BsFillCheckCircleFill
          color={ColorSchema.success_custom}
          style={{ width: 20, height: 20 }}
        />
      );
    } else if (data.toastType == "failed") {
      return (
        <RiCloseCircleFill
          color={ColorSchema.danger_custom}
          style={{ width: 20, height: 20 }}
        />
      );
    } else if (data.toastType == "warning") {
      return (
        <AiFillWarning
          color={ColorSchema.warning_custom}
          style={{ width: 20, height: 20 }}
        />
      );
    } else if (data.toastType == "info") {
      return (
        <BsFillInfoCircleFill
          color={ColorSchema.primary_custom}
          style={{ width: 20, height: 20 }}
        />
      );
    } else return <></>;
  };
  const toastContainer = toast.custom(
    <div
      className="shadow text-center"
      style={{ width: 300, borderRadius: data.hasHeader ? 5 : 10 }}
    >
      {data.hasHeader ? (
        <div
          className="p-2 rounded  d-flex align-items-center justify-content-between"
          style={{
            backgroundColor: ColorSchema[`${data.color}_custom`],
            color: data.color.includes("light")
              ? ColorSchema[`${data.color.replace("_light", "")}_custom`]
              : "white",
          }}
        >
          <span>{data.headerText}</span>

          <GrClose
            onClick={() => toast.dismiss(id)}
            style={{ cursor: "pointer" }}
          />
        </div>
      ) : (
        <></>
      )}
      <div
        className="py-3 px-2 d-flex justify-content-center"
        style={{
          backgroundColor: "white",
          borderRadius: data.hasHeader ? 5 : 10,
          border: data.hasHeader
            ? "none"
            : `1px solid ${ColorSchema[`${data.color}_custom`]}`,
        }}
      >
        <div className="me-2">{ToastType()}</div>
        <div>{data.mainText}</div>
      </div>
    </div>,
    {
      ...styles,
    }
  );
  const id = toastContainer;

  return toastContainer;
}
